import notifications from 'notifications';
import preferences from 'Preferences';

import {HUMAN_REQUEST_CONFIRMATION_MESSAGE, StartPreferences} from './StartConstants';
import * as StartDAO from './StartDAO';

export function requestDemoFromProduct(demoType: string): void {
  StartDAO.requestDemoFromProduct(demoType)
    .done(() => {
      notifications.success(HUMAN_REQUEST_CONFIRMATION_MESSAGE);
      preferences.set(`${StartPreferences.REQUESTED_DEMO_NAMESPACE}${demoType}`, true);
    })
    .fail(notifications.notifyError);
}
